<div class="pt-container mat-elevation-z8">

  <!-- Fot now it's best soluyion, but maybe in future we should use provider loading state here to avoid block page on global loading -->
  <div class="pt-loading-shade"
       *ngIf="(isLoading | async) > 0">
  </div>

  <div class="pt-table-container" [class.grow]="heightGrow">

    <table mat-table [dataSource]="dataSource" class="pt-table">

      <ng-container *ngFor="let field of fields"
                    [matColumnDef]="field.name"
                    [sticky]="field.sticky"
                    [stickyEnd]="field.stickyEnd">
        <th mat-header-cell *matHeaderCellDef>
          <span *ngIf="field | showField:'text'">{{ field.title | async }}</span>
        </th>
        <td mat-cell *matCellDef="let row"
            [class.pt-table__icon-cell]="field | showField:'btn'">

          <span *ngIf="field | showField:'text'">{{ field.dataGenerator(row[field.name]) | skipPrimitives }}</span>
          <span *ngIf="field | showField:'btn'">
            <button mat-icon-button
                    [matTooltip]="field.title | async"
                    (click)="field.clickHandler(row, $event)">
              <mat-icon [color]="field.color" [svgIcon]="field.iconName"></mat-icon>
            </button>
          </span>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <mat-paginator [length]="resultsLength" [pageSize]="provider!.page.pageSize"></mat-paginator>
</div>
